import cloneDeep from 'lodash/cloneDeep';
import trim from 'lodash/trim';
import round from 'lodash/round';
import compact from 'lodash/compact';
import debounce from 'lodash/debounce';
import startsWith from 'lodash/startsWith';
import orderBy from 'lodash/orderBy';
import sortBy from 'lodash/sortBy';
import set from 'lodash/set';

export { cloneDeep, trim, round, compact, debounce, startsWith, orderBy, sortBy, set };

export const get = (obj, path, defaultValue = undefined) => {
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

export const pick = (object, keys) => {
  return keys.reduce((obj, key) => {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
};

export const removeKey = (obj, key) =>
  obj !== Object(obj)
    ? obj
    : Array.isArray(obj)
    ? obj.map(item => removeKey(item, key))
    : Object.keys(obj)
        .filter(k => k !== key)
        .reduce((acc, x) => Object.assign(acc, { [x]: removeKey(obj[x], key) }), {});
